module.exports = __webpack_public_path__ + "static/media/page_not_found.769655e4.png";